import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';

@modelOptions({ schemaOptions: { collection: 'appliedPolicies' }, options: { customName: 'appliedPolicies' } })
export class AppliedPolicies {
  @prop({ required: true, _id: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  endpointId: mongoose.Types.ObjectId;

  @prop({ required: true })
  policyId: mongoose.Types.ObjectId;

  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: false })
  appliedOn?: Date;

  @prop({ required: false })
  confirmed?: boolean;
}
